import React from "react";

/**
 * PremiumVerifiedBadge - Compact, premium verified seller badge
 * RTL-safe, works in Arabic and English
 * 
 * @param {boolean} verified - Whether seller is verified
 * @param {string} lang - Language code ('en' or 'ar')
 * @param {string} className - Additional CSS class
 */
export function PremiumVerifiedBadge({
  verified,
  lang,
  className = "",
}) {
  if (!verified) return null;

  const isAr = (lang || "").toLowerCase().startsWith("ar");
  const label = isAr ? "موثّق" : "Verified";

  return (
    <span
      dir={isAr ? "rtl" : "ltr"}
      className={className}
      data-testid="premium-verified-badge"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "4px 10px",
        borderRadius: 999,
        border: "1px solid rgba(16,185,129,0.35)",
        background: "rgba(16,185,129,0.10)",
        color: "#0F766E",
        fontSize: 12,
        fontWeight: 700,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
      aria-label={label}
      title={label}
    >
      {/* Small premium check icon */}
      <span
        aria-hidden="true"
        style={{
          width: 16,
          height: 16,
          borderRadius: 999,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(16,185,129,0.18)",
          border: "1px solid rgba(16,185,129,0.35)",
          flex: "0 0 16px",
        }}
      >
        <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
          <path
            d="M10.2 3.2L5.1 8.3L1.8 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span style={{ letterSpacing: isAr ? 0 : 0.2 }}>{label}</span>
    </span>
  );
}

export default PremiumVerifiedBadge;
